(() => {
  const key = 'zeya:recently-viewed:v1';
  if (customElements.get('zeya-recently-viewed')) return;
  customElements.define('zeya-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.clearButton = this.querySelector('[data-clear]');
      this.onClear = () => {
        try { window.localStorage.removeItem(key); this.load(); }
        catch { this.show('[data-storage-error]', true); }
      };
      this.onRetry = () => this.load();
      this.onStorage = event => { if (event.key === key || event.key === null) this.load(); };
      this.onPageShow = event => { if (event.persisted) this.load(); };
      this.clearButton.addEventListener('click', this.onClear);
      this.querySelector('[data-retry]').addEventListener('click', this.onRetry);
      window.addEventListener('storage', this.onStorage);
      window.addEventListener('pageshow', this.onPageShow);
      this.load();
    }

    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.controller?.abort();
      this.clearButton.removeEventListener('click', this.onClear);
      this.querySelector('[data-retry]').removeEventListener('click', this.onRetry);
      window.removeEventListener('storage', this.onStorage);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    show(selector, visible) { this.querySelector(selector).hidden = !visible; }

    count(value) {
      this.querySelector('[data-count]').textContent = value === 1 ? this.dataset.countOne : this.dataset.countMany.replace('[count]', String(value));
    }

    async load() {
      const generation = this.generation = (this.generation || 0) + 1;
      this.controller?.abort();
      const controller = this.controller = new AbortController();
      this.grid.replaceChildren();
      for (const selector of ['[data-empty]', '[data-fallback]', '[data-error]', '[data-storage-error]']) this.show(selector, false);
      this.show('[data-loading]', false);
      this.clearButton.hidden = true;
      this.setAttribute('aria-busy', 'false');
      let history;
      try {
        const raw = window.localStorage.getItem(key);
        let stored;
        try { stored = JSON.parse(raw || '[]'); } catch { stored = []; }
        history = [...new Set((Array.isArray(stored) ? stored : []).filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle)))].slice(0, 20);
      } catch {
        this.dataset.state = 'blocked';
        this.count(0);
        this.show('[data-storage-error]', true);
        this.show('[data-fallback]', true);
        return;
      }
      this.count(history.length);
      if (!history.length) {
        this.dataset.state = 'empty';
        this.show('[data-empty]', true);
        this.show('[data-fallback]', true);
        return;
      }
      this.dataset.state = 'loading';
      this.clearButton.hidden = false;
      this.show('[data-loading]', true);
      this.setAttribute('aria-busy', 'true');
      const slots = history.map(() => {
        const slot = document.createElement('div');
        slot.className = 'zeya-recently-viewed__skeleton';
        slot.setAttribute('aria-hidden', 'true');
        this.grid.append(slot);
        return slot;
      });
      const missing = new Set();
      let next = 0;
      let rendered = 0;
      let failed = false;
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      const worker = async () => {
        while (next < history.length && generation === this.generation) {
          const index = next++;
          try {
            const response = await window.fetch(`${this.dataset.root}products/${encodeURIComponent(history[index])}?section_id=zeya-recently-viewed-card`, { signal: controller.signal, credentials: 'same-origin' });
            if (generation !== this.generation) return;
            if (response.status === 404 || response.status === 410) {
              missing.add(history[index]);
              slots[index].remove();
              continue;
            }
            if (!response.ok) throw new Error('Product unavailable');
            const html = await response.text();
            if (generation !== this.generation) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const card = parsed.querySelector('product-block[data-product-id]');
            if (!card) throw new Error('Product card unavailable');
            slots[index].replaceWith(card);
            rendered++;
          } catch {
            if (generation !== this.generation) return;
            failed = true;
            slots[index].remove();
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, history.length) }, worker));
      window.clearTimeout(timeout);
      if (generation !== this.generation) return;
      if (missing.size) {
        try {
          const fresh = JSON.parse(window.localStorage.getItem(key) || '[]');
          if (Array.isArray(fresh)) window.localStorage.setItem(key, JSON.stringify(fresh.filter(handle => !missing.has(handle))));
        } catch {}
      }
      this.setAttribute('aria-busy', 'false');
      this.show('[data-loading]', false);
      this.count(rendered);
      this.show('[data-error]', failed);
      this.dataset.state = failed ? 'error' : rendered ? 'ready' : 'empty';
      if (!rendered && !failed) {
        this.clearButton.hidden = true;
        this.show('[data-empty]', true);
        this.show('[data-fallback]', true);
      }
    }
  });
})();
